// Activation confirmation modal (slice 4a-3). Activation is irreversible —
// the modal makes that unmissable before the POST /activate fires. Same
// owner-themed overlay shape as LogoCropModal.

export function ActivateConfirmModal({
  onConfirm,
  onCancel,
  isActivating,
  isMembership = false,
}: {
  onConfirm: () => void
  onCancel: () => void
  isActivating: boolean
  /** Membership programs lock a different set of fields than loyalty, so the
   *  warning copy differs. */
  isMembership?: boolean
}) {
  return (
    <div
      className="owner-modal-backdrop"
      role="presentation"
      onClick={() => {
        if (!isActivating) onCancel()
      }}
    >
      <div
        className="owner-modal"
        role="dialog"
        aria-modal="true"
        aria-label={
          isMembership ? 'Activate membership program' : 'Activate loyalty program'
        }
        onClick={(e) => e.stopPropagation()}
      >
        <div className="owner-modal-head">
          <h3>Activate this program?</h3>
        </div>
        {isMembership ? (
          <p className="owner-card-sub">
            Once active, customers can enroll and you{' '}
            <strong>can't change the sign-up fields you collect or the card
            expiry</strong>. Tiers, benefits, colors, links, and terms stay
            editable, and apply to new members.
          </p>
        ) : (
          <p className="owner-card-sub">
            Once active, customers can enroll and you{' '}
            <strong>can't change the stamps, milestones, sign-up fields, or
            expiry</strong>. Colors, links, and terms stay editable.
          </p>
        )}
        <div className="owner-modal-actions">
          <button
            type="button"
            className="owner-btn"
            onClick={onCancel}
            disabled={isActivating}
          >
            Not yet
          </button>
          <button
            type="button"
            className="owner-btn owner-btn-primary"
            onClick={onConfirm}
            disabled={isActivating}
          >
            {isActivating ? 'Activating…' : 'Yes, activate'}
          </button>
        </div>
      </div>
    </div>
  )
}
